import type { IconSvgObject } from './types';

const PaintBucketIcon: IconSvgObject = [
  ["path", { d: "M20 12.5H3", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M22 20C22 21.1046 21.1046 22 20 22C18.8954 22 18 21.1046 18 20C18 18.8954 20 17 20 17C20 17 22 18.8954 22 20Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9.59914 2L11.5803 3.98299M11.5803 3.98299L20 12.4107L11 21.4192C10.2263 22.1936 8.97195 22.1936 8.19828 21.4192L2.58026 15.7959C1.80658 15.0215 1.80658 13.7659 2.58026 12.9915L11.5803 3.98299Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default PaintBucketIcon;
